import { useTranslation } from "react-i18next";
import { useState } from "react";
import { HiOutlineUpload } from "react-icons/hi";

const FileInput = ({ id, formik, name, label, accept }) => {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);

  const allowedTypes = ["image/gif", "image/png", "image/jpeg"];
  const maxSizeInBytes = 10 * 1024 * 1024; // 10MB

  const validateFile = (file) => {
    if (!allowedTypes.includes(file.type)) {
      alert(t("invalidFileType"));
      return false;
    }
    if (file.size > maxSizeInBytes) {
      alert(t("fileTooLarge"));
      return false;
    }
    return true;
  };

  const handleFile = (file) => {
    if (validateFile(file)) {
      formik.setFieldValue(name, file);
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) handleFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  return (
    <div>
      {label && (
        <label className="block mb-1 font-semibold capitalize text-primary">
          {label}
        </label>
      )}
      <label
        htmlFor={id}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className={`block p-4 my-3 border border-dashed cursor-pointer transition-colors min-h-[204px]
        ${isDragging ? "border-blue-500 bg-blue-50" : "border-white"}`}
      >
        <HiOutlineUpload className="mx-auto text-[#888888]" size={32} />

        <h1 className="my-4 font-medium text-center text-white">
          <span className="text-primary">{t("uploadFile")}</span>
          {t("orDragAndDrop")}
        </h1>
        <p className="text-center text-mainGray dark:text-gray-400">
          {t("maximumUploadLimit")}
        </p>
        <p className="text-center dark:text-green-400">
          {formik?.values?.[name]?.name}
        </p>
        <input
          type="file"
          id={id}
          name={id}
          onChange={handleChange}
          className="hidden"
          accept={accept || ".gif, .png, .jpg, .jpeg"}
        />
      </label>
    </div>
  );
};

export default FileInput;
